import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconData({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#CD0400"
					fillRule="nonzero"
					d="M4.863 11.22H1.297c-.23 0-.417-.197-.417-.44s.186-.44.417-.44h3.566c.23 0 .417.197.417.44s-.187.44-.417.44M5.95 8.36H4.391c-.238 0-.431-.197-.431-.44s.193-.44.43-.44h1.56c.237 0 .43.197.43.44s-.193.44-.43.44m-1.98 5.5H2.41c-.238 0-.43-.197-.43-.44s.193-.44.43-.44h1.56c.237 0 .43.197.43.44s-.193.44-.43.44"
				/>
				<path
					fill="#000"
					fillRule="nonzero"
					d="M13.737 16.804a2 2 0 0 1-.144-.177c-.405-.57-.46-1.361-.153-2.228l2.368-6.7c.322-.91.985-1.736 1.794-2.335zM22.724 4.72c-.525-.74-1.396-1.149-2.453-1.149-2.14 0-4.491 1.73-5.243 3.854l-2.369 6.7c-.391 1.108-.297 2.194.259 2.978.526.74 1.397 1.149 2.454 1.149 2.14 0 4.491-1.729 5.242-3.854l.591-1.669c.008-.023.006-.047.01-.07s.014-.043.014-.067q-.002-.007-.003-.013c0-.03-.01-.059-.018-.088-.006-.023-.008-.047-.017-.068-.011-.024-.029-.043-.044-.065-.016-.022-.028-.045-.047-.063-.017-.016-.039-.026-.057-.039-.026-.017-.05-.036-.08-.047q-.005-.004-.01-.006c-.022-.008-.044-.006-.067-.01s-.046-.014-.07-.014h-3.208a.413.413 0 0 0 0 .825h2.623l-.397 1.12c-.644 1.822-2.645 3.303-4.462 3.303a2.6 2.6 0 0 1-.92-.16l4.231-12.522a4.1 4.1 0 0 1 1.588-.348c.78 0 1.412.283 1.779.8.405.57.46 1.362.153 2.228a.412.412 0 0 0 .39.55.41.41 0 0 0 .39-.276c.392-1.109.298-2.195-.258-2.979M6.11 14.813l.27-.778 4.774.001-.27.777zm5.466.504.517-1.485a.4.4 0 0 0 .053-.152l.3-.863a.413.413 0 0 0-.251-.526.41.41 0 0 0-.522.253l-.232.667-4.774-.001 2.007-5.792a.413.413 0 0 0-.251-.526.407.407 0 0 0-.522.254L5.148 15.09c-.008.022-.006.045-.01.068-.003.023-.013.044-.013.068l.003.012c0 .031.01.06.017.089.006.023.009.047.018.068q.018.034.043.064c.015.022.028.046.047.064.017.016.037.025.056.038q.037.029.08.048.005.002.01.006a.4.4 0 0 0 .135.023h5.063l-1.64 4.713a.414.414 0 0 0 .252.526.406.406 0 0 0 .522-.253l1.81-5.206a.4.4 0 0 0 .035-.101"
				/>
			</g>
		</svg>
	);
}
